<template>
  <article class="edit-search-parts disp-scroll">
    <section class="top-section ">
      <p class="section-name -right-8px"><b>メッセージ</b></p>
      <input class="input is-small"
        maxlength="200"
        v-model="scenarioEdit.parameter.message"
        :disabled="scenarioEdit.is_confirm"/>
    </section>
    <section>
      <p class="section-name -right-8px"><b>検索ワードの初期値設定</b></p>
      <input class="input is-small"
        v-model="scenarioEdit.parameter.default_search_word"
        :disabled="scenarioEdit.is_confirm"/>
    </section>
    <section>
      <p class="section-name -right-8px"><b>自動検索</b></p>
      <div class="switch-wrapper">
        <b-switch size="is-small"
        v-model="scenarioEdit.parameter.is_search"
        :disabled="scenarioEdit.is_confirm"></b-switch>
      </div>
    </section>
    <section>
      <p class="section-name -right-8px"><b>引用値クリア</b></p>
      <div class="switch-wrapper">
        <b-switch size="is-small"
        v-model="scenarioEdit.parameter.is_clear"
        :disabled="scenarioEdit.is_confirm"></b-switch>
　      <span style="color: #666; font-size: 11px;">
  　      ※初期値設定上に設定されている引用値に対して有効となります。
    　  </span>
      </div>
    </section>
    <section>
      <p class="-right-8px">
        <b>検索内容の入力</b><br><b>（検索ワードは空白で区切ることができます。</b><br><b>検索ワードの1単語は2文字以上にしてください。）</b>
      </p>
      <div v-if="!scenarioEdit.is_confirm">
        <b-upload v-model="csvSearchFile"
          accept=".csv"
          v-if="user.isAgent">
          <a class="button is-small">
            <b-icon icon="upload"></b-icon>
            <span>CSVインポート（カンマ区切り）</span>
          </a>
        </b-upload>
      </div>
      <div v-else>
        <a class="button is-small" :disabled="scenarioEdit.is_confirm">
          <b-icon icon="upload"></b-icon>
          <span>CSVインポート（カンマ区切り）</span>
        </a>
      </div>
      <a class="button is-small" style="margin-left: 8px;"
      :download="download_file" id="download" @click="csvSearchFileExport()">
        <b-icon icon="download"></b-icon>
        <span>CSVエクスポート（カンマ区切り）</span>
      </a>
    </section>
    <section class="table-section">
      <table>
        <tr>
          <th class="search-th">検索ワード</th>
          <th class="search-th">タイプ</th>
          <th class="search-th">タイトル</th>
          <th class="search-th">詳細</th>
          <th class="search-th">URL</th>
          <th class="search-th">連携ID</th>
          <th class="search-th">画像</th>
          <th class="search-th">操作</th>
        </tr>
        <tr v-for="(s, idx) in scenarioEdit.parameter.search" :key="idx">
          <td class="search-td">
            <textarea class="textarea is-small"
              maxlength="200"
              v-model="s.keywords"
              :disabled="scenarioEdit.is_confirm"></textarea>
          </td>
          <td class="search-td">
            <select v-model="s.type"
              class="select is-small -left-8px -right-8px"
              :disabled="scenarioEdit.is_confirm">
              <option v-for="(t, idx) in ['なし', 'URL', '応募フォーム']"
                :key="idx"
                :value="idx">
                {{t}}
              </option>
            </select>
          </td>
          <td class="search-td">
            <textarea class="textarea is-small"
              maxlength="100"
              v-model="s.title"
              :disabled="scenarioEdit.is_confirm"></textarea>
          </td>
          <td class="search-td">
            <textarea class="textarea is-small"
              maxlength="500"
              v-model="s.description"
              :disabled="scenarioEdit.is_confirm"></textarea>
          </td>
          <td class="search-td">
            <textarea class="textarea is-small"
              maxlength="255"
              v-model="s.url"
              :disabled="s.type!=1 || scenarioEdit.is_confirm"></textarea>
          </td>
          <td class="search-td">
            <textarea class="textarea is-small"
              maxlength="50"
              v-model="s.renkeiID"
              :disabled="s.type!=2 || scenarioEdit.is_confirm"></textarea>
          </td>
          <td class="search-td">
            <div class="button-container img-button-container">
              <template v-if="s.image_ref">
                <template v-if="!s.image_ref.name">
                  <button
                    class="button is-small is-primary"
                    @click="openSelectModal('image'); editSearch(s);"
                    :disabled="scenarioEdit.is_confirm">
                    追加
                  </button>
                </template>
                <template v-else>
                  <div class="img-wrapper">
                    <img :src="s.image_ref.image_data">
                  </div>
                  <div class="delete-btn" @click="deleteSearchImg(s)">
                    <i class="mdi mdi-delete mdi-24px"></i>
                  </div>
                </template>
              </template>
            </div>
          </td>
          <td class="search-td">
            <div class="button-container">
              <button
                @click="addSearchRecord(idx)"
                class="button is-small is-primary"
                :disabled="scenarioEdit.is_confirm">追加</button>
              <button
                @click="delSearchRecord(idx)"
                class="button is-small is-danger -left-8px"
                :disabled="scenarioEdit.is_confirm">削除</button>
            </div>
          </td>
        </tr>
      </table>
    </section>
    <div style="margin-top: 25px;" v-if="existApplyItem">
      <p style="text-align: left">
        <b>メール無効　</b>
        <span style="color: #666; font-size: 12px">
          ONにしますと、応募完了メールを送付しません。
        </span>
      </p>
    </div>
    <div style="justify-content: center" v-if="existApplyItem">
      <b-switch v-model="scenarioEdit.parameter.disable_email" :disabled="scenarioEdit.is_confirm">{{scenarioEdit.parameter.disable_email ? "送付しない" : "送付する"}}</b-switch>
    </div>
  </article>
</template>

<script>
import Encoding from 'encoding-japanese'
export default {
  props: {
    scenarioEdit: {
      type: Object,
    },
    user: {
      type: Object
    }
  },
  data () {
    return {
      csvSearchFile: null,
      download_file: 'search_list.csv',
    }
  },
  mounted () {
    if (!this.scenarioEdit.parameter.disable_email) this.scenarioEdit.parameter.disable_email = false
  },
  computed : {
    existApplyItem() {
      return this.scenarioEdit.parameter.search.some((item)=>item.type==2)
    }
  },
  watch: {
    csvSearchFile () {
      if (this.csvSearchFile) {
        this.csvSearchFileImport()
      }
    }
  },
  methods: {
    addSearchRecord (idx) {
      this.$emit('add-search-record', idx)
    },
    delSearchRecord (idx) {
      this.$emit('del-search-record', idx)
    },
    openSelectModal (type) {
      this.$emit('open-select-modal', type)
    },
    editSearch (s) {
      this.$emit('edit-search', s)
    },
    deleteSearchImg(s) {
      this.$emit('delete-search-img', s)
    },
    // CSV インポート（検索用）
    csvSearchFileImport () {
      let reader = new FileReader()
      reader.onload = (e) => {
        const res = new Uint8Array(e.target.result)
        const encoding = Encoding.detect(res)
        const data = Encoding.convert(res, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        })
        const header = '検索ワード,タイプ,タイトル,詳細,URL,連携ID\n'
        let content = data.replace(header, '')

        const re = RegExp(',".*?",', 'gs')
        let temp = content
        let block;
        let replaceSet = {}
        while((block = re.exec(temp)) !== null) {
          const randstr = Math.random().toString(32).substring(2)

          replaceSet['<'+randstr+'>'] = block[0].substring(2, block[0].length-2)
          content = content.replace(block[0], ',<'+randstr+'>,')
        }

        let arr = content.trim().replace(/\"/g, "").replace(/\r/g, "").split("\n").map(v => v.split(","))
        arr = arr.map((col) => col.map((cell) => (cell in replaceSet ? replaceSet[cell] : cell)))

        let searchArr = []
        for (let i in arr) {
          let param = {
            keywords: '',
            type: '',
            title: '',
            description: '',
            url: '',
            renkeiID: '',
            title: ''
          }
          for (let j in arr[i]) {
            switch (Number(j)) {
              case 0:
                param.keywords = arr[i][j] != 'なし' ? arr[i][j].replace(/<br>/g, '\n').replace(/&cma;/g, ',') : ''
                break
              case 1:
                if (!arr[i][j]) {
                  param.type = 0
                } else if (arr[i][j].indexOf('URL') >= 0) {
                  param.type = 1
                } else if (arr[i][j].indexOf('応募フォーム') >= 0) {
                  param.type = 2
                } else {
                  param.type = 0
                }
                break
              case 2:
                param.title = arr[i][j] != 'なし' ? arr[i][j].replace(/<br>/g, '\n').replace(/&cma;/g, ',') : ''
                break
              case 3:
                param.description = arr[i][j] != 'なし' ? arr[i][j].replace(/<br>/g, '\n').replace(/&cma;/g, ',') : ''
                break
              case 4:
                param.url = arr[i][j] != 'なし' ? arr[i][j].replace(/<br>/g, '\n') .replace(/&cma;/g, ','): ''
                break
              case 5:
                param.renkeiID = arr[i][j] != 'なし' ? arr[i][j].replace(/<br>/g, '\n') .replace(/&cma;/g, ','): ''
                break
            }
          }
          searchArr.push(param)
        }
        if (searchArr.length > 0) {
          this.$emit('outputSearch', searchArr)
        } else {
          alert('正しく挿入できませんでした。')
        }
        this.csvSearchFile = null
      }
      reader.readAsArrayBuffer(this.csvSearchFile)
    },
    // CSV エクスポート（検索用）
    csvSearchFileExport () {
      const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      for (let i in this.scenarioEdit.parameter.search) {
        this.scenarioEdit.parameter.search[i]['keywords'] = this.scenarioEdit.parameter.search[i]['keywords'].replace(/\n/g, '<br>')
        this.scenarioEdit.parameter.search[i]['title'] = this.scenarioEdit.parameter.search[i]['title'].replace(/\n/g, '<br>')
        this.scenarioEdit.parameter.search[i]['description'] = this.scenarioEdit.parameter.search[i]['description'].replace(/\n/g, '<br>')
        this.scenarioEdit.parameter.search[i]['url'] = this.scenarioEdit.parameter.search[i]['url'].replace(/\n/g, '<br>')
        this.scenarioEdit.parameter.search[i]['renkeiID'] = this.scenarioEdit.parameter.search[i]['renkeiID'].replace(/\n/g, '<br>')
      }
      const content = this.scenarioEdit.parameter.search.map(
        item => [
          item.keywords != '' ? item.keywords.replace(/,/g, '&cma;') : 'なし', ['なし', 'URL', '応募フォーム'][item.type],
          item.title != '' ? item.title.replace(/,/g, '&cma;') : 'なし',
          item.description != '' ? item.description.replace(/,/g, '&cma;') : 'なし',
          item.url != '' ? item.url.replace(/,/g, '&cma;') : 'なし',
          item.renkeiID != '' ? item.renkeiID.replace(/,/g, '&cma;') : 'なし'
        ].join(',')
      ).join('\n')
      const header = '検索ワード,タイプ,タイトル,詳細,URL,連携ID\n'
      const csv_content = header + content
      const blob = new Blob([bom, csv_content], {'type': 'text/csv'})
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, this.download_file)
        window.navigator.msSaveOrOpenBlob(blob, this.download_file)
      } else {
        document.getElementById('download').href = window.URL.createObjectURL(blob)
      }
      for (let i in this.scenarioEdit.parameter.search) {
        this.scenarioEdit.parameter.search[i]['keywords'] = this.scenarioEdit.parameter.search[i]['keywords'].replace(/<br>/g, '\n')
        this.scenarioEdit.parameter.search[i]['title'] = this.scenarioEdit.parameter.search[i]['title'].replace(/<br>/g, '\n')
        this.scenarioEdit.parameter.search[i]['description'] = this.scenarioEdit.parameter.search[i]['description'].replace(/<br>/g, '\n')
        this.scenarioEdit.parameter.search[i]['url'] = this.scenarioEdit.parameter.search[i]['url'].replace(/<br>/g, '\n')
        this.scenarioEdit.parameter.search[i]['renkeiID'] = this.scenarioEdit.parameter.search[i]['renkeiID'].replace(/<br>/g, '\n')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.edit-search-parts {
  height: 500px;
  section {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 16px;
    .section-name {
      width: 200px;
    }
  }
  .top-section {
    margin-top: 0;
  }
  .table-section {
    margin-top: 8px;
  }
  .search-td {
    vertical-align: middle;
    border: solid thin #ccc;
    input {
      min-height: 36px;
      background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; height: 100%; width: 100%;
    }
    textarea {
      min-height: 36px;
      resize: none;
      background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; height: 100%; width: 100%;
    }
  }
  .search-th {
    text-align: center;
    vertical-align: middle;
    border: solid thin #ccc;
  }
  .switch-wrapper {
    width: 100%;
  }
  .button-container {
    display: flex;
    align-items: center;
    margin: 0 8px;
  }
  .img-button-container {
    width: 144px;
    justify-content: center;
  }
  .img-wrapper {
    width: 80px;
    display: flex;
    align-items: center;
    margin-right: 6px;
    img {
      width: 80px;
    }
  }
  .delete-btn {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditSearchParts.vue